import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import './styles.scss'
import * as bootstrap from 'bootstrap'
import 'boxicons'

createApp(App).use(router).mount('#app')
